import {useMutation} from "@khan/data-gql";

import {DELETE_BLOOKET_QUESTION_SET_MUTATION} from "../graphql/delete-blooket-question-set-mutation.ts";

export const useDeleteBlooketQuestionSetMutation = () => {
    const [deleteBlooketQuestionSetMutation] = useMutation(
        DELETE_BLOOKET_QUESTION_SET_MUTATION,
    );

    return deleteBlooketQuestionSetMutation;
};
